/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import { TextField, Dialog, FlatButton, Snackbar } from 'material-ui'

import * as actions from 'actions/Login'
import { messages } from 'constants/Login'

class Contact extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      contact: undefined,
      error: undefined
    }
  }

  componentDidMount () {
    actions.getContact()
      .then((result) => {
        this.setState({
          contact: result.data.object
        })
      })
  }

  handleChange (event, value) {
    const name = event.target.name

    this.setState({
      contact: {
        ...this.state.contact,
        [name]: value
      }
    })
  }

  handleSubmit () {
    actions.postContact(this.state.contact)
      .then(() => {
        this.setState({
          contact: undefined,
          error: undefined
        })

        this.props.handleCancel({success: true})
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          this.setState({
            error: error.response.data.object
          })
        }
      })
  }

  handleCancel () {
    this.setState({
      contact: undefined,
      error: undefined
    })

    this.props.handleCancel({success: undefined})
  }

  render () {
    const contact = this.state.contact || {}
    const errors = this.state.error || {}

    return (
      <React.Fragment>
        <Snackbar
          open={!!this.props.confirmation}
          message={this.props.intl.formatMessage(messages.CONFIRMATION_CONTACT)}
          autoHideDuration={40000}
          onRequestClose={this.props.handleConfirmationClose}
          bodyStyle={{height: 'auto', lineHeight: '28px', padding: 24, whiteSpace: 'pre-line'}}
        />
        <Dialog
          title={this.props.intl.formatMessage(messages.CONTACT_TITLE_LABEL)}
          modal={false}
          autoScrollBodyContent={true}
          open={this.props.open}
          actions={[
            <FlatButton
              label={this.props.intl.formatMessage(messages.CONTACT_ACTION_CANCEL)}
              onClick={this.handleCancel}
            />,
            <FlatButton
              label={this.props.intl.formatMessage(messages.CONTACT_ACTION_SUBMIT)}
              primary={true}
              onClick={this.handleSubmit}
            />
          ]}
        >
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='last_name'
                floatingLabelText={this.props.intl.formatMessage(messages.LAST_NAME_LABEL)}
                value={contact.last_name}
                onChange={this.handleChange}
                errorText={errors.last_name}
                fullWidth
              />
            </div>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='first_name'
                floatingLabelText={this.props.intl.formatMessage(messages.FIRST_NAME_LABEL)}
                value={contact.first_name}
                onChange={this.handleChange}
                errorText={errors.first_name}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='entity'
                floatingLabelText={this.props.intl.formatMessage(messages.ENTITY_LABEL)}
                value={contact.entity}
                onChange={this.handleChange}
                errorText={errors.entity}
                fullWidth
              />
            </div>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='corporate_function'
                floatingLabelText={this.props.intl.formatMessage(messages.FUNCTION_LABEL)}
                value={contact.corporate_function}
                onChange={this.handleChange}
                errorText={errors.corporate_function}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='phone_number'
                floatingLabelText={this.props.intl.formatMessage(messages.PHONE_LABEL)}
                value={contact.phone_number}
                onChange={this.handleChange}
                errorText={errors.phone_number}
                fullWidth
              />
            </div>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='email'
                floatingLabelText={this.props.intl.formatMessage(messages.EMAIL_LABEL)}
                value={contact.email}
                onChange={this.handleChange}
                errorText={errors.email}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='address'
                floatingLabelText={this.props.intl.formatMessage(messages.ADDRESS_LABEL)}
                value={contact.address}
                onChange={this.handleChange}
                errorText={errors.address}
                fullWidth
              />
            </div>
            <div className='col-sm-2 col-xs-6'>
              <TextField
                name='np'
                floatingLabelText={this.props.intl.formatMessage(messages.NP_LABEL)}
                value={contact.np}
                onChange={this.handleChange}
                errorText={errors.np}
                fullWidth
              />
            </div>
            <div className='col-sm-4 col-xs-6'>
              <TextField
                name='location'
                floatingLabelText={this.props.intl.formatMessage(messages.LOCATION_LABEL)}
                value={contact.location}
                onChange={this.handleChange}
                errorText={errors.location}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='responsible_last_name'
                floatingLabelText={this.props.intl.formatMessage(messages.RESPONSIBLE_LAST_NAME_LABEL)}
                value={contact.responsible_last_name}
                onChange={this.handleChange}
                errorText={errors.responsible_last_name}
                fullWidth
              />
            </div>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='responsible_first_name'
                floatingLabelText={this.props.intl.formatMessage(messages.RESPONSIBLE_FIRST_NAME_LABEL)}
                value={contact.responsible_first_name}
                onChange={this.handleChange}
                errorText={errors.responsible_first_name}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='responsible_phone_number'
                floatingLabelText={this.props.intl.formatMessage(messages.RESPONSIBLE_PHONE_LABEL)}
                value={contact.responsible_phone_number}
                onChange={this.handleChange}
                errorText={errors.responsible_phone_number}
                fullWidth
              />
            </div>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='responsible_email'
                floatingLabelText={this.props.intl.formatMessage(messages.RESPONSIBLE_EMAIL_LABEL)}
                value={contact.responsible_email}
                onChange={this.handleChange}
                errorText={errors.responsible_email}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <TextField
                name='responsible_corporate_function'
                floatingLabelText={this.props.intl.formatMessage(messages.RESPONSIBLE_FUNCTION_LABEL)}
                value={contact.responsible_corporate_function}
                onChange={this.handleChange}
                errorText={errors.responsible_corporate_function}
                fullWidth
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12'>
              <TextField
                name='remark'
                floatingLabelText={this.props.intl.formatMessage(messages.REMARK_LABEL)}
                value={contact.remark}
                onChange={this.handleChange}
                errorText={errors.remark}
                fullWidth
                multiLine
              />
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    )
  }
}

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
})

export default withRouter(connect(null, mapActionsToProps)(injectIntl(Contact)))



// WEBPACK FOOTER //
// ./src/components/authentication/Contact.js